const page_schema = {
	"tiers": [
		{
			"name": "Downstream Analysis",
			"type": "checkbox",
			"id": "downstream-analysis",
			"class_name": "tags",
			"child_name": "downstream-analysi",
			"options": [
				{
					"name": "PCR/qPCR",
					"id": "pcr-qpcr"
				},
				{
					"name": "Antibody",
					"id": "antibody"
				},
				{
					"name": "NGS",
					"id": "ngs"
				},
				{
					"name": "LC/MS",
					"id": "lc-ms"
				},
			]
		},
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-none",
			"class_name": "tags",
			"child_name": "dnone",
			"options": [
				{
					"name": "Hydroxymethylation",
					"id": "hydroxymethylation"
				},
				{
					"name": "5-mc-antibodies-enrichment",
					"id": "5-mc-antibodies-enrichment"
				}
			]
		},
	],
	"filters": [],
	"products": {
		"OneStep qMethyl-PCR Kit": {
			"title": "OneStep qMethyl-PCR Kit",
			"catalogNumbers": "D5310, D5311",
			"description": "The OneStep qMethyl Kit provides a simple, straightforward, and bisulfite-free procedure for rapid, locus-specific DNA methylation assessment via the selective amplification of a methylated region of DNA. This is accomplished by splitting any DNA to be tested into two parts: a \"Test Reaction\" and a \"Reference Reaction\". DNA in the Test Reaction is digested with Methylation Sensitive Restriction Enzymes (MSREs) while DNA in the Reference Reaction is not. The DNA from both samples is then amplified using real-time PCR in the presence of SYTO 9 fluorescent dye and quantitated using a simple equation.",
			"handle": "/products/onestep-qmethyl-pcr-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5310_OneStep-qMethyl.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "onestep-qmethyl-pcr-kit",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"ZymoTaq Premix": {
			"title": "ZymoTaq Premix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated \"master mix\" containing all the reagents needed to perform \"hot start\" PCR. The inclusion of a heat-activated, thermal-stable DNA polymerase reduces primer dimer and non-specific product formation that can occur when performing conventional PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection.",
			"handle": "/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform \"hot-start\" PCR. The inclusion of a heat-activated, thermostable DNA polymerase reduces primer dimer and nonspecific product formation that can occur during PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
			"handle": "/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays. This premix features a hot-start DNA polymerase and buffer system optimized for the amplification of bisulfite-treated DNA. It also includes an intense dsDNA-specific fluorescent dye, SYTO 9, for sensitive real-time DNA quantification.",
			"handle": "/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"5-mC DNA ELISA Kit": {
			"title": "5-mC DNA ELISA Kit",
			"catalogNumbers": "D5325, D5326",
			"description": "The 5-mC DNA ELISA Kit allows researchers to accurately quantitate 5-mC in any DNA sample in less than 3 hours. The kit features an Anti-5-Methylcytosine monoclonal antibody that is both sensitive and specific for 5-mC. The assay is compatible with a wide range of input DNA from vertebrate, plant, and microbial sources as well as methylated PCR amplicons and fragmented DNA. Percent 5-mC in a DNA sample can be accurately quantified from a standard curve generated with specially designed controls included with the kit.",
			"handle": "/products/5-mc-dna-elisa-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5325_5-mC_20DNA_20ELISA_20Kit.png?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "5-mc-dna-elisa-kit",
			"tags": [
				"antibody",
			],
			filters: []
		},
		"Quest 5-hmC DNA ELISA Kit": {
			"title": "Quest 5-hmC DNA ELISA Kit",
			"catalogNumbers": "D5425, D5426",
			"description": "The Quest 5-hmC DNA ELISA Kit is both sensitive and specific and can be used to accurately detect 5-hmC DNA in a variety of samples. The kit is compatible with a wide range of input DNA including intact vertebrate, plant, and microbial genomic DNA, as well as enzyme-digested and mechanically sheared fragments. The Control DNA Set included with this kit has been calibrated to accurately quantify the percent 5-hmC in sample DNA by use of a standard curve. Also, the fast, streamlined workflow is ideal when analyzing/screening large numbers of samples.",
			"handle": "/products/quest-5-hmc-dna-elisa-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5425_Quest_205-hmC_20DNA_20ELISA_20Kit.png?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "quest-5-hmc-dna-elisa-kit",
			"tags": [
				"antibody",
				"hydroxymethylation",
			],
			filters: []
		},
		"Methylated-DNA IP Kit": {
			"title": "Methylated-DNA IP Kit",
			"catalogNumbers": "D5101",
			"description": "The Methylated-DNA IP Kit is designed for enrichment of 5mC-containing DNA from any pool of fragmented genomic DNA for use in genome-wide methylation analysis. It features a highly specific Anti-5-Methylcytosine Monoclonal Antibody for the immunoprecipitation of methylated DNA in only a few hours. This kit is capable of achieving over one hundred-fold enrichment of methylated DNA vs. non-methylated DNA. Recovered DNA is suitable for many downstream applications to analyze genome-wide DNA methylation including PCR, bisulfite treatment, whole-genome amplification, ultra-deep sequencing, and microarray.",
			"handle": "/products/methylated-dna-ip-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5101_Methylated-DNA-IP-Kit.jpg?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "methylated-dna-ip-kit",
			"tags": [
				"antibody",
				"5-mc-antibodies-enrichment",
			],
			filters: []
		},
		"Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)": {
			"title": "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
			"catalogNumbers": "A3002-15, A3002-200, A3002-30, A3002-50",
			"description": "The mouse Anti-5-Methylcytosine Monoclonal Antibody specifically recognizes methylated cytosines. The antibody binds to 5-mC in single-stranded DNA, with no detectable cross-reactivity to non-methylated or hydoxymethylated cytosines. This product is ideal for immuno-based assays such as methylated DNA Immunoprecipitation (MeDIP), ELISA and dot blot.",
			"handle": "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A3002-50_Anit_20Methylation_20-_201_2ul.png?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
			"tags": [
				"antibody",
				"5-mc-antibodies-enrichment",
			],
			filters: []
		},
		"Anti-5-Hydroxymethylcytosine Polyclonal Antibody": {
			"title": "Anti-5-Hydroxymethylcytosine Polyclonal Antibody",
			"catalogNumbers": "A4001-200, A4001-25, A4001-50",
			"description": "The rabbit Anti-5-hmC Polyclonal Antibody can robustly distinguish between hydroxymethylated DNA and methylated or unmodified DNA with limited to no cross-reactivity. The antibody has been validated in ELISA and immunoprecipitation-based enrichment assays, and is suitable for use in further applications including immunohistochemical labeling and chromatographic blotting.",
			"handle": "/products/anti-5-hydroxymethylcytosine-polyclonal-antibody",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A4001-25_Anti-5-Hydroxymethylcytosine_20Polyclonal_20Antibody_20-_2025_20ug.png?v=1628532400&width=600",
			"generalIndex": "998",
			"id": "anti-5-hydroxymethylcytosine-polyclonal-antibody",
			"tags": [
				"antibody",
				"hydroxymethylation",
			],
			filters: []
		},
		"RRHP 5-hmC Library Prep Kit": {
			"title": "RRHP 5-hmC Library Prep Kit",
			"catalogNumbers": "D5450, D5451",
			"description": "The RRHP 5-hmC Library Prep Kit is an all-inclusive solution for analysis of genome-wide 5-hydroxymethylcytosine (5-hmC) positions at single-base resolution. The Reduced Representation Hydroxymethylation Profiling (RRHP) method is based on blocking MspI digestion by glucosylating 5-hmC within MspI recognition sites. Fragments lacking glucosylated 5-hmC at the adapter-ligation junction will be cleaved and not amplified by PCR. Therefore, only fragments containing 5-hmC will be successfully amplified and analyzed by Next-Generation Sequencing.",
			"handle": "/products/rrhp-5-hmc-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5450_RRHP_205-hmC_20Library_20Prep_20Kit.png?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "rrhp-5-hmc-library-prep-kit",
			"tags": [
				"ngs",
				"hydroxymethylation",
			],
			filters: []
		},
		"DNA Degradase Plus": {
			"title": "DNA Degradase Plus",
			"catalogNumbers": "E2020, E2021",
			"description": "DNA Degradase Plus from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleoside components. Since nucleosides lack negatively charged phosphate, DNA Degradase Plus is ideal for whole-genome DNA methylation analysis by LC/MS. Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2020_DNA-Degradase-Plus.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dna-degradase-plus",
			"tags": [
				"lc-ms",
				"hydroxymethylation",
			],
			filters: []
		},
		"5-mC DNA ELISA kit": {
			"title": "5-mC DNA ELISA kit",
			"catalogNumbers": "D5325, D5326",
			"description": "The 5-mC DNA ELISA Kit allows researchers to accurately quantitate 5-mC in any DNA sample in less than 3 hours.",
			"handle": "/products/5-mc-dna-elisa-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D5325_5-mC_20DNA_20ELISA_20Kit_600x.png",
			"generalIndex": "998",
			"id": "5-mc-dna-elisa-kit",
			"tags": [
				"antibody",
				"5-mc-antibodies-enrichment",
			],
			filters: []
		},
		"Mouse 5-hmC & 5-mC DNA Set": {
			"title": "Mouse 5-hmC & 5-mC DNA Set",
			"catalogNumbers": "D5019, D5019-1, D5019-2, D5019-3, D5019-4",
			"description": "The Mouse 5-hmC & 5-mC DNA Set is a set of organ specific mouse genomic DNAs isolated from a pool of 8-10 week old Swiss Webster mice.",
			"handle": "/products/mouse-5hmc-5mc-dna-set",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D5019_Mouse-hmC-and-5-mC-DNA_600x.jpg",
			"generalIndex": "998",
			"id": "mouse-5hmc-5mc-dna-set",
			"tags": [
				"pcr-qpcr",
				"ngs",
				"lc-ms",
				"hydroxymethylation",
			],
			filters: []
		},
		"5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set": {
			"title": "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
			"catalogNumbers": "D5405",
			"description": "The 5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set is a set of three standards that are linear dsDNA at a length of 897 bp.",
			"handle": "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2020_DNA-Degradase-Plus.jpg",
			"generalIndex": "998",
			"id": "5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"tags": [
				"lc-ms",
				"hydroxymethylation",
			],
			filters: []
		},
	}
}